import React, { useEffect } from "react"
import CollectionTiles from "./components/CollectionTiles";
import {getCookie} from "../common/utils";
import PersonalizedCartModule from "./components/PersonalizedCartModule";
import {openShopifyCart} from "../actionCreators/shopifyAC";
import PersonalizedCarouselModule from "./components/PersonalizedCarouselModule";
import "./Homepage.scss";
import LazyLoad from "react-lazyload"
import { useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import RetinaImage from "react-retina-image";
import config from "../../config";
import DiscoverCollections from "../NewHomepage/DiscoverCollections";
import PersonalizedRPlusSellerReminder from "./components/PersonalizedRPlusSellerReminder";

const Homepage = () => {
    const { home_details, mobile_small, mobile_medium, user_logged_in, isInternational, selectedCountry, cartCount, cart } = useSelector(state => ({
        home_details: state.appReducer.home_details,
        mobile_medium: state.appReducer.mobile_medium,
        mobile_small: state.appReducer.mobile_small,
        user_logged_in: state.appReducer.user_logged_in,
        isInternational: state.appReducer.isInternational,
        selectedCountry: state.appReducer.selectedCountry,
        cartCount: state.shopifyReducer.cartCount,
        cart: state.shopifyReducer.cart,
    }));
    const force_homepage_hero = getCookie('force_homepage_hero');

    useEffect(() => {
        if (window.gbTracker) {
            window.gbTracker.sendHomePageViewEvent({
                products: [],
            });
        }
    }, [window.gbTracker]);
    return (
        <div className="homepage">
            {user_logged_in && !force_homepage_hero &&
                <div className="homepage__row homepage__row--personalization">
                    <PersonalizedRPlusSellerReminder/>
                    {cartCount > 0 &&
                        <PersonalizedCartModule
                            cartCount={cartCount}
                            cart={cart}
                            openShopifyCart={openShopifyCart}
                            isInternational={isInternational}
                            selectedCountry={selectedCountry}
                        />
                    }
                    <PersonalizedCarouselModule />
                </div>
            }
            <div className="homepage__row homepage__row--collection-tiles">
                <CollectionTiles
                    home_details={home_details}
                    mobile_medium={mobile_medium}
                    mobile_small={mobile_small}
                />
            </div>
            <div className="homepage__row homepage__row--member-bloom-tiles">
                <div className="homepage__big-tile-container">
                    <div className="homepage__big-tile homepage__big-tile--sell">
                        <LazyLoad height={650} offset={100} once={true}>
                            <RetinaImage
                                alt="Become a member"
                                src={`${config.MEDIA_URL}/img/homepage-big-tile-member${mobile_medium ? "-mobile" : ""}.jpg`}
                                className="homepage__big-tile-image"
                            />
                        </LazyLoad>
                        <div className="homepage__big-tile-content">
                            <div className="homepage__big-tile-title">
                                Sell with Rebag
                            </div>
                            <div className="homepage__big-tile-text">
                                We offer three easy selling methods—Consign, Trade, and Buyout—giving you control over how you sell, what you earn, and how quickly you're paid. Plus, Rebag⁺ members
                                get up to 5% higher payouts on every sale.
                            </div>
                            <Button
                                className="rbg-btn-white homepage__big-tile-button"
                                variant="clean"
                                href={`${config.host_rebag}/selling-with-rebag/`}
                            >
                                Learn More
                            </Button>
                        </div>
                    </div>
                    <div className="homepage__big-tile homepage__big-tile--store">
                        <div className="homepage__big-tile-content">
                            <div className="homepage__big-tile-title">
                                Visit us in Person
                            </div>
                            <div className="homepage__big-tile-text">
                                Shop our expertly vetted handbags, watches, and fine jewelry at Rebag boutiques in California, Florida, and New York, plus select Bloomingdale's locations nationwide.
                            </div>
                            <Button
                                className="rbg-btn-dark homepage__big-tile-button"
                                variant="clean"
                                href={`${config.host_rebag}/store/`}
                            >
                                Learn More
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="homepage__row homepage__row---discover-carousels">
                <LazyLoad height={600} offset={100} once={true}>
                    <div className="homepage-new__best-sellers">
                        <DiscoverCollections />
                    </div>
                </LazyLoad>
            </div>
            <div className="homepage__row homepage__row--consignment-banner">
                <div className="homepage__banner">
                    <LazyLoad height={650} offset={100} once={true}>
                        <RetinaImage
                            alt="Consignment"
                            src={`${config.MEDIA_URL}/img/homepage-banner-consignment${mobile_small ? "-mob" : ""}.jpg`}
                            className="homepage__banner-image"
                        />
                    </LazyLoad>
                    <div className="homepage__banner-content">
                        <div className="homepage__banner-title">
                            Consignment
                        </div>
                        <div className="homepage__banner-text">
                            Try our newest selling method and enjoy unparalleled control and flexibility
                        </div>
                        <Button
                            className="homepage__banner-button"
                            variant="clean"
                            href={`${config.host_rebag}/consign/`}
                        >
                            Learn More
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Homepage;
